import { render } from "./TrickSection.vue?vue&type=template&id=62501613&scoped=true"
import script from "./TrickSection.vue?vue&type=script&lang=js"
export * from "./TrickSection.vue?vue&type=script&lang=js"

import "./TrickSection.vue?vue&type=style&index=0&id=62501613&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62501613"]])

export default __exports__